<template>
  <div
    v-if="props.item"
    class="note-origin"
  >
    <div
      v-if="props.item.title"
      class="note-origin__title"
    >
      {{ props.item.title }}
    </div>
    <div
      v-if="props.item.date || props.item.company"
      class="note-origin__date"
    >
      {{props.item.company}} {{ formatISODateToDDMMYYYYWithTime(props.item.date) }}
    </div>
  </div>
</template>

<script setup>
import { formatISODateToDDMMYYYYWithTime } from '@/utils/dateTime'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})
</script>

<style scoped src="./NoteOrigin.css"></style>
